// @flow
export { default } from './PostLikeButton';



// WEBPACK FOOTER //
// ./src/components/post/PostLikeButton/index.js